import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: "faq-1",
  question: "Koja su osnovna ograničenja dostupnosti usluge?",
  answer: "Naša platforma se pruža u stanju 'kakvo jest' (as is). Iako nastojimo osigurati maksimalnu dostupnost, ne možemo jamčiti neprekidan pristup usluzi bez tehničkih smetnji ili planiranih održavanja sustava."
}, {
  id: "faq-2",
  question: "Postoje li jamstva na točnost pruženih informacija?",
  answer: "Ne dajemo nikakva izričita ili podrazumijevana jamstva u pogledu točnosti, pouzdanosti ili potpunosti sadržaja. Korisnici koriste informacije na vlastitu odgovornost i potiču se na neovisnu provjeru ključnih podataka."
}, {
  id: "faq-3",
  question: "Kako se definira ograničenje odgovornosti za štetu?",
  answer: "U najvećoj mjeri dopuštenoj zakonom, nećemo biti odgovorni za bilo kakvu izravnu, neizravnu, slučajnu ili posljedičnu štetu proizašlu iz korištenja ili nemogućnosti korištenja naših digitalnih usluga."
}, {
  id: "faq-4",
  question: "Što se događa u slučaju prekida rada sustava?",
  answer: "Zadržavamo pravo na privremeni prekid rada radi nadogradnje, popravaka ili hitnih intervencija. Takvi prekidi ne predstavljaju kršenje ugovornih obveza niti daju pravo na naknadu štete."
}, {
  id: "faq-5",
  question: "Mogu li se uvjeti pružanja usluge promijeniti bez najave?",
  answer: "Zadržavamo pravo izmjene funkcionalnosti i uvjeta korištenja u bilo kojem trenutku. Nastavak korištenja platforme nakon objave promjena smatra se vašim prihvaćanjem novih uvjeta i ograničenja."
}, {
  id: "faq-6",
  question: "Postoje li geografska ograničenja za korištenje usluge?",
  answer: "Iako je platforma dostupna globalno, određene značajke mogu biti ograničene na specifična tržišta ili regije u skladu s lokalnim zakonodavstvom i našim poslovnim politikama."
}, {
  id: "faq-7",
  question: "Koja je odgovornost korisnika za sigurnost računa?",
  answer: "Korisnik je isključivo odgovoran za čuvanje povjerljivosti svojih pristupnih podataka. Ne preuzimamo odgovornost za gubitke nastale neovlaštenim pristupom vašem računu zbog vašeg nemara."
}, {
  id: "faq-8",
  question: "Kako rješavate sporove vezane uz ograničenja usluge?",
  answer: "Svi sporovi nastojat će se riješiti mirnim putem. U slučaju nemogućnosti dogovora, nadležan je sud prema sjedištu pružatelja usluge, primjenjujući važeće zakone Republike Hrvatske."
}];
export default function FrequentlyAskedQuestions() {
  return <section data-section-id="257583" id="ograničenja-usluge" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="page-container max-w-4xl">
        <Accordion type="single" collapsible className="w-full flex flex-col gap-4">
          {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="border-none bg-card rounded-lg shadow-md px-4 md:px-8">
              <AccordionTrigger className="font-default text-lg md:text-[18px] font-bold text-foreground hover:no-underline py-6 text-left [&>svg]:text-primary [&>svg]:bg-primary/10 [&>svg]:rounded-lg [&>svg]:p-1.5 [&>svg]:size-8 [&>svg]:shrink-0">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="font-default text-base md:text-[16px] text-muted-foreground pb-6 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}